// The service-worker update check, for a manual "Check for updates" (Settings → About).
// UpdatePrompt owns the whole update flow (register, poll, apply — components/UpdatePrompt.jsx) and
// registers its checker here while it's mounted (tenant portals, once the page is shown);
// callers never touch the service worker themselves.
//   checkForUpdate() → 'updated' (a new build is being applied: the page reloads onto it)
//                    | 'current' (already the latest) | 'unsupported' (no service worker here)
let checker = null;

export function setUpdateChecker(fn) {
  checker = fn;
  return () => { if (checker === fn) checker = null; };
}

export async function checkForUpdate() {
  if (!checker) return 'unsupported';
  try { return await checker({ reloadIfCurrent: false }); } catch { return 'unsupported'; }
}
